import { createFileRoute, redirect } from "@tanstack/react-router";

import { buildLocalizedPagePath } from "@/lib/localized-page-path";

export const Route = createFileRoute("/_legal/contact/")({
  beforeLoad: ({ context: { locale } }) => {
    throw redirect({ href: buildLocalizedPagePath(locale, "contact"), statusCode: 301 });
  },
});
